export default {
    activityLog: 'ประวัติกิจกรรม',
    sortByLasted: 'เรียงตามกิจกรรมล่าสุด',
    sortByEarliest: 'เรียงตามกิจกรรมก่อน'
}
